
import { Component, Vue } from 'vue-property-decorator';
import { Tag as ITag } from '@/api/interfaces';
import Tag from '@/components/tags/Tag.vue';
import { repositories } from '@/api/ApiFactory';
import { namespace } from 'vuex-class';
import { USER_NAMESPACE_PATH } from '@/store/namespaces.type';
import { IS_ADMIN } from '@/store/getters.type';
import ErrorHandler from '@/components/shared/errorHandler';

const userModule = namespace(USER_NAMESPACE_PATH);


@Component ({
  components: {
    Tag,
  },
})
export default class TagList extends Vue {
  @userModule.Getter(IS_ADMIN) private isAdmin!: boolean;
  private loading = false;

  private tags: ITag[] = [];

  private async fetchTags() {
    this.loading = true;
    try {
      const { data } =
        await repositories.core.tag.getTags();
      this.tags = data.results;
    } catch (error) {
      this.$toasted.error(
        new ErrorHandler(
          { error, status: true },
          { itemMessageText: 'značkah' },
        ).toString(),
      );
    }
    this.loading = false;
  }

  private created() {
    this.fetchTags();
  }

  private removeTag(tag: ITag) {
    this.tags = this.tags.filter((x) => x.id !== tag.id);
  }

  private updateTag(tag: ITag) {
    const matchingIdx = this.tags.findIndex((el) => el.id === tag.id);
    this.tags.splice(matchingIdx, 1, tag);
  }

  private openAddOrEditTagModal() {
    const promise: Promise<ITag> = this.$modals.open(
      'app-add-or-edit-tag-modal',
      {
        component: {
          props: {
            data: null,
          },
        },
        dialog: {
          props: {
            'max-width': '600px',
          },
        },
      },
    ) as Promise<ITag>;
    promise.then((innerTag: ITag) => {
      this.tags.push(innerTag);
    });
  }
}
